



import { useNavigate, useParams } from "react-router-dom";
import Login from '../../../components/azuldirecta/transmisiones/transmisioneslandig'
import React, { useEffect, useState } from "react";
import FooterNavigation from '../../../components/azuldirecta/footer'; // Ajustá la ruta si es necesario


export default function Paginas() {
 
   

    return (
        <>
    
   
        <Login/>
       <FooterNavigation/>
        </>
   
    );

}